import { render, staticRenderFns } from "./interactive-arts.vue?vue&type=template&id=5ea8bd8f&scoped=true&"
import script from "./interactive-arts.vue?vue&type=script&lang=js&"
export * from "./interactive-arts.vue?vue&type=script&lang=js&"
import style0 from "./interactive-arts.vue?vue&type=style&index=0&id=5ea8bd8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea8bd8f",
  null
  
)

export default component.exports